module.exports = __webpack_public_path__ + "img/candles-off.75d2f5d7.png";